import { patchAsync as _patchAsync } from "../../api";

const BASE_URL = "/calendar-notifications";

export async function notifySingleReminder(guestId) {
    return _patchAsync({
        url: `${BASE_URL}/notify-single/${guestId}`,
    });
}